import { RepairOrderPricing } from '../sdk'

export function getRepairOrderPricing(repairOrderPricing: RepairOrderPricing) {
  const totalLaborPrice = repairOrderPricing.laborRetailPrice || 0
  const totalPartsPrice = repairOrderPricing.partsRetailPrice || 0
  const totalSublet = repairOrderPricing.sublet || 0
  const totalTaxes = repairOrderPricing.taxes || 0
  const shopSuppliesFee = repairOrderPricing.shopSuppliesFee || 0
  const shopHazmatFee = repairOrderPricing.shopHazmatFee || 0
  const customFees = repairOrderPricing.customFees || 0
  const warrantyTotal =
    (repairOrderPricing.partWarrantyTotal || 0) +
    (repairOrderPricing.laborWarrantyTotal || 0)
  const discountTotal = repairOrderPricing.discountTotal || 0
  const repairOrderDiscount = repairOrderPricing.repairOrderShopDiscount || 0
  const serviceDiscount = discountTotal - repairOrderDiscount
  const estimateTotal = repairOrderPricing.total || 0
  const estimateTotalWithSurcharge = repairOrderPricing.totalWithSurcharge || 0
  const subtotal =
    totalLaborPrice +
    totalPartsPrice +
    shopSuppliesFee +
    shopHazmatFee +
    customFees -
    warrantyTotal -
    discountTotal
  return {
    totalLaborPrice,
    totalPartsPrice,
    totalSublet,
    totalTaxes,
    shopSuppliesFee,
    shopHazmatFee,
    customFees,
    warrantyTotal,
    discountTotal,
    repairOrderDiscount,
    serviceDiscount,
    estimateTotal,
    estimateTotalWithSurcharge,
    subtotal
  }
}
